export default (first, last) => `${first} ${last}`;
